module.exports = __webpack_public_path__ + "img/icon_e32.0e20da9b.png";